import React, { Component } from "react";
import { push } from "redux-little-router";
import { connect } from "react-redux";
import { deletePost as deleteCase } from "../../../../actions/postActions";
import { showConfirmDialog, hideConfirmDialog } from "../../../../actions";
import { selectUserId, selectUser } from "../../../../util/selectors";
import { constructPostSlugPath } from "../../../../util/index";
import CaseActionsDropdown from "../CaseActionsDropdown";
import AdminCaseActionsDropdown from "../AdminCaseActionsDropdown";

class CaseActionsDropdownContainer extends Component {
  constructor(props) {
    super(props);
    this.post = this.props.post;
    const { actions } = this.props;
    this.isOwnPost = this.isOwnPost.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this);
    this.deleteCurrentPost = this.deleteCurrentPost.bind(this);

    this.defaultDropdownOptions = [
      {
        key: `edit_${this.post._id}`,
        text: "Edit Case",
        onClick: () => actions.editCase(this.post),
      },
      {
        key: `delete_${this.post._id}`,
        text: "Delete Case",
        onClick: this.openConfirmDialog,
      },
    ];
  }

  isOwnPost() {
    const postUserId = this.props.post.owner.id;
    return this.props.currentUserId && postUserId === this.props.currentUserId;
  }

  isAdmin() {
    return this.props.currentUser && this.props.currentUser.isAdmin;
  }

  openConfirmDialog() {
    this.props.actions.showConfirmDialog({
      onConfirm: this.deleteCurrentPost,
      onCancel: this.props.actions.hideConfirmDialog,
      content: "Are you sure you want to delete this case?",
      confirmText: "Delete",
      confirmColor: "red",
    });
  }

  deleteCurrentPost() {
    this.props.actions.hideConfirmDialog();
    const isInSinglePostView = this.props.currentRoute === "/posts/:id" || this.props.currentRoute === "/case/:slug";
    const redirectionRoute = isInSinglePostView ? `/profile/${this.props.currentUserId}` : null;
    this.props.actions.deleteCase(this.post._id, redirectionRoute);
  }

  render() {
    if (this.isAdmin()) {
      return (
        <AdminCaseActionsDropdown
          isOwnPost={this.isOwnPost()}
          defaultOptions={this.defaultDropdownOptions}
          post={this.props.post}
        />
      );
    }

    if (this.isOwnPost()) {
      return <CaseActionsDropdown options={this.defaultDropdownOptions} post={this.props.post} />;
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    currentUserId: selectUserId(state),
    currentRoute: state.router.route,
    currentUser: selectUser(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      editCase: post => dispatch(push(`${constructPostSlugPath(post)}/edit`)),
      deleteCase: (postId, redirectionRoute) => dispatch(deleteCase(postId, redirectionRoute)),
      showConfirmDialog: options => dispatch(showConfirmDialog(options)),
      hideConfirmDialog: () => dispatch(hideConfirmDialog()),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseActionsDropdownContainer);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/CaseActionsDropdownContainer/index.js